var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.637 2.636a.75.75 0 0 1 1.06 1.061L4.312 5.083H10.5a4.75 4.75 0 0 1 0 9.5H7.833a.75.75 0 0 1 0-1.5H10.5a3.25 3.25 0 0 0 0-6.5H4.31l1.387 1.386a.75.75 0 0 1-1.06 1.061L1.979 6.372l-.01-.008a.755.755 0 0 1-.082-.96l.022-.032a1 1 0 0 1 .06-.07z"
  })));
};
export default Svg16;